<template>
  <div :class="bem('wrapper')">
    <div :id="'TextRevealSection-' + props.section.id" :class="bem()">
      <ScrollRevealTitle
        :class="bem('title', {
          background: true
        })"
        :bg-colour="'black'"
        :heading="props.section.content.titleTextReveal"
      />
      <ScrollRevealTitle
        :class="bem('title', {
          foreground: true
        })"
        :bg-colour="'black'"
        fill-type="opacity"
        :heading="props.section.content.titleTextReveal"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
interface TextRevealSectionProps {
  section: {
    id: string,
    internalTitle: string
    content: {
      titleTextReveal: object | null
    }
    textHighlightTheme: {
      buttonBackgroundColour?: {
        hex?: string
      }
    }
  }
  rowPosition: number
}

const props = defineProps<TextRevealSectionProps>()

const { gsap } = useGsap()
const highlightColour = ref(props.section.textHighlightTheme?.buttonBackgroundColour?.hex)

const bem = useBEM('TextRevealSection')

onMounted(() => {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: '#TextRevealSection-' + props.section.id,
      start: 'top 90%',
      end: '80% center',
      scrub: 1.3,
      invalidateOnRefresh: true
    },
  })

  const titleFillAreas = gsap.utils.toArray(`#TextRevealSection-${props.section.id} .TextRevealSection__title--foreground .ScrollRevealTitle__title`)

  titleFillAreas.forEach(titleFillArea => {
    timeline.set(titleFillArea, {
      opacity: 0
    })

    timeline.to(titleFillArea, {
      opacity: 1,
      ease: 'none',
    })
  })
})
</script>

<style lang="postcss">
.TextRevealSection__wrapper {
  @apply global-wrapper
}

.TextRevealSection {
  @apply relative
    flex items-center justify-center
    max-w-5xl mx-auto;

  .ScrollRevealTitle {
    @apply heading-2 lg:heading-1;

    .ScrollRevealTitle__sentence {
      @apply mb-5 lg:mb-10;
    }
  }
}

.TextRevealSection__title {
  --highlight-fill-colour: v-bind('highlightColour');
  --normal-fill-colour: white;
}

.TextRevealSection__title--foreground {
  @apply absolute left-0;
}

</style>